module.exports = __webpack_public_path__ + "img/organization-active.f9639129.svg";